var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSearchNormal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.69423 13.4999C10.9005 13.4999 13.4998 10.9007 13.4998 7.69435C13.4998 4.48803 10.9005 1.88879 7.69423 1.88879C4.48791 1.88879 1.88867 4.48803 1.88867 7.69435C1.88867 10.9007 4.48791 13.4999 7.69423 13.4999Z",
    stroke: "#46515A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1109 14.111L12.8887 12.8888",
    stroke: "#46515A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchNormal);
export default __webpack_public_path__ + "static/media/ic_search_normal.72657fcdcb1e6442edf859e14289eec3.svg";
export { ForwardRef as ReactComponent };